import React, {useEffect, useContext} from "react";
import { isWebAuthnEnabled } from "../../../../utils";
import classNames from "classnames";
import {
  DotActive,
  DotInactive, faceidSVG,
  faceidSVGInactive, keySVG,
  keySVGInactive, LockActive, LockInactive, touchidSVG,
  touchidSVGInactive
} from "../../../../constants/images";
import {PasswordContext} from "../../../../contexts/PasswordContext";
import {Tooltip, Typography} from "@one-thd/sui-atomic-components";
import {Info} from "@one-thd/sui-icons";

function WebAuthnIconsActive() {
  return (
        <div className="icons-for-webauthn">
            {faceidSVG} {touchidSVG} {keySVG}
        </div>
  )
}

function WebAuthnIconsInactive() {
  return (
        <div className="icons-for-webauthn">
            {faceidSVGInactive} {touchidSVGInactive} {keySVGInactive}
        </div>
  )
}

function WebAuthn({isCurrentDeviceWebAuthnCapable}) {
  const {passwordOptions, setPasswordOptions} = useContext(PasswordContext)

  const isSelected = passwordOptions === "passwordless"
  const isWebAuthnActive = isCurrentDeviceWebAuthnCapable && isWebAuthnEnabled();

  const toolTipText = "Instead of entering a password you may access your account by using a one-time passcode that we can email, text or call you with. After we verify that this is your account we will keep you signed in on this device for an extended period of time."
  const IconSrcActive = (isWebAuthnActive) ? <WebAuthnIconsActive /> : <LockActive />
  const IconSrcInactive = (isWebAuthnActive) ? <WebAuthnIconsInactive /> : <LockInactive />

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div className={classNames("options-toggle-button-container", isSelected ? "active" : "inactive")}
         onClick={() => setPasswordOptions("passwordless")}>
        <div className="sui-absolute sui-left-0 sui-top-0 sui-p-2">
            <Tooltip placement="top-end" offset="relaxed" title={toolTipText}>
                <Info />
            </Tooltip>
        </div>
        {isSelected && <img className="selected-icon" src="https://assets.thdstatic.com/images/v1/alert-check-white.svg" alt=""/>}
        {isSelected ? IconSrcActive : IconSrcInactive}
        <Typography align='center' color={isSelected ? "primary" : "inactive"}>Sign In without a Password</Typography>
        <Typography variant='body-xs' color={isSelected ? "primary" : "inactive"}>( Suggested )</Typography>
    </div>
  )
}

function Password() {
  const {passwordOptions, setPasswordOptions} = useContext(PasswordContext)
  const isSelected = passwordOptions === "password" 
  return (
      <button className={classNames("options-toggle-button-container", isSelected ? "active" : "inactive")} type='button' onClick={() => setPasswordOptions("password")}>
        {isSelected && <img className="selected-icon" src="https://assets.thdstatic.com/images/v1/alert-check-white.svg" alt=""/>}
        {isSelected ? <DotActive /> : <DotInactive />}
        <Typography color={isSelected ? "primary" : "inactive"}>Sign In with a Password</Typography>
      </button>
  )
}

export const OptionsToggle = (props) => {
  const {
    isCurrentDeviceWebAuthnCapable
  } = props;
  
  const {setPasswordOptions, isUserPasswordlessEnrolled} = useContext(PasswordContext)

  useEffect(() => {
    setPasswordOptions(isUserPasswordlessEnrolled ? "passwordless" : "password");
  }, []);

  return (
        <div className="sui-grid sui-gap-4 md:sui-gap-4 lg:sui-gap-4 sui-justify-items-stretch sui-grid-cols-2 sui-min-h-8">
          <WebAuthn isCurrentDeviceWebAuthnCapable={isCurrentDeviceWebAuthnCapable} />
          <Password />
        </div>
  );
};

export default OptionsToggle;